import { confirmGridAction } from './confirm'

export default function gridSelection(Swal) {
  return {
    props: { selectionContext: { type: Object, default: null } },
    data: () => ({ selecaoEmMassa: false, selecaoSubstitui: false, confirmandoSelecao: false, versaoSelecao: 0 }),
    beforeDestroy() { this.versaoSelecao++ },
    methods: {
      definirSelecao(rows = []) {
        const selecionados = this.singleSelect ? rows.slice(0, 1) : rows
        const chaves = selecionados.map(item => this.chaveLinha(item, this.rows.indexOf(item)))
        this.versaoSelecao++
        this.selecaoSubstitui = false
        this.selecaoEmMassa = chaves.length > 1 || !!this.selectionContext?.mass
        if (chaves.length !== this.selecionados.length || chaves.some(chave => !this.selecionados.includes(chave))) this.selecionados = chaves
      },
      async permitirSelecaoEmMassa() {
        if (this.singleSelect || this.confirmandoSelecao) return false
        if (this.selecaoEmMassa || this.selectionContext?.mass) { this.selecaoEmMassa = true; return true }
        const versao = this.versaoSelecao
        this.confirmandoSelecao = true
        try {
          const confirmou = await confirmGridAction(Swal, {
            title: 'Ativar seleção em massa?',
            text: 'Você está selecionando mais de um registro. As ações disponíveis poderão ser aplicadas a todos os itens selecionados.',
            confirmButtonText: 'Selecionar em massa', cancelButtonText: 'Manter seleção única'
          }, this.$el)
          if (!confirmou || this._isDestroyed || versao !== this.versaoSelecao) return false
          this.selecaoEmMassa = true
          return true
        } finally { this.confirmandoSelecao = false }
      },
      async alternarItem(item, index, event) {
        const chave = this.chaveLinha(item, index)
        // O estado nativo muda antes do change; a confirmação não deve deixar um check fantasma.
        if (event) event.target.checked = this.selecionados.includes(chave)
        if (this.confirmandoSelecao) return
        this.selecaoSubstitui = false
        this.indiceTeclado = index
        if (this.singleSelect) {
          this.selecionados = this.selecionados.includes(chave) ? [] : [chave]
          this.versaoSelecao++
        } else if (this.selecionados.includes(chave)) {
          this.selecionados = this.selecionados.filter(key => key !== chave)
          this.versaoSelecao++
        } else {
          if ((this.selecionados.length || this.selectionContext?.count > 0) && !await this.permitirSelecaoEmMassa()) return
          this.selecionados = [...this.selecionados, chave]
          this.versaoSelecao++
        }
        if (!this.selecionados.length) this.selecaoEmMassa = false
      },
      clicarItem(item, index) {
        if (this.confirmandoSelecao) return
        this.versaoSelecao++
        this.selecaoEmMassa = false
        this.selecaoSubstitui = true
        this.indiceTeclado = index
        this.selecionados = this.selecionados.length === 1 && this.itemSelecionado(item, index) ? [] : [this.chaveLinha(item, index)]
      },
      async alternarTodos(event) {
        if (event) {
          event.target.checked = !this.singleSelect && this.todosSelecionados
          event.target.indeterminate = this.singleSelect ? this.quantidadeSelecionada > 0 : this.algunsSelecionados
        }
        if (this.confirmandoSelecao) return
        this.selecaoSubstitui = false
        if (this.singleSelect || this.todosSelecionados) return this.limparSelecao()
        if ((this.linhasOrdenadas.length > 1 || this.selectionContext?.count > this.selecionados.length) && !await this.permitirSelecaoEmMassa()) return
        this.selecionados = this.linhasOrdenadas.map((item, index) => this.chaveLinha(item, index))
        this.versaoSelecao++
      },
      limparSelecao() {
        this.versaoSelecao++
        this.selecaoEmMassa = false
        this.selecaoSubstitui = false
        this.selecionados = []
      }
    }
  }
}
